import React, { useMemo } from 'react';
import { Button, Menu, MenuItem, MenuTrigger, OverlayArrow, Popover } from 'react-aria-components';
import SvgIcon from '../../utils/SvgIcon';

type ContextMenuItem = {
  id: string;
  label: string;
  onSelect: () => void;
};

type ContextMenuProps = Readonly<{
  trigger: React.ReactNode;
  items: ContextMenuItem[];
  triggerClassName?: string;
  menuClassName?: string;
  popoverClassName?: string;
  ariaLabel?: string;
  placement?: 'bottom' | 'bottom right' | 'bottom left' | 'top' | 'top right' | 'top left';
}>;

export default function ContextMenu({
  trigger,
  items,
  triggerClassName = '',
  menuClassName = 'context-menu',
  popoverClassName = 'context-menu__popover',
  ariaLabel = 'Menu',
  placement = 'bottom',
}: ContextMenuProps) {
  const getCrossOffset = (placement: string): number => {
    if (placement.includes('left')) return -13;
    if (placement.includes('right')) return 13;
    return 0;
  };

  const crossOffset = useMemo(() => getCrossOffset(placement), [placement]);

  return (
    <MenuTrigger>
      <Button className={triggerClassName} aria-label={ariaLabel}>
        {trigger}
      </Button>
      <Popover className={popoverClassName} placement={placement} offset={18} crossOffset={crossOffset}>
        <OverlayArrow>
          <SvgIcon iconName="solid-triangle" className="context-menu__arrow-icon" viewBox="0 0 20 10" />
        </OverlayArrow>
        <Menu className={menuClassName} onAction={key => items.find(item => item.id === key)?.onSelect()}>
          {items.map(item => (
            <MenuItem key={item.id} id={item.id} className="context-menu__item">
              {item.label}
            </MenuItem>
          ))}
        </Menu>
      </Popover>
    </MenuTrigger>
  );
}
